import {
  ADD_PAGE_TO_VIEWED,
  LOAD_PAGE_TO_VIEWED,
  RESET_PAGE_TO_VIEWED } from '../../action-types/ui/addPageToViewed';

export const STATE_KEY = 'addPageToViewed';

export const addPageToViewed = (state = { 10: 10 }, action) => {
  switch (action.type) {
    case ADD_PAGE_TO_VIEWED: {
      const { pageId } = action;
      return {
        ...state,
        [pageId]: pageId,
      };
    }

    case LOAD_PAGE_TO_VIEWED: {
      return action.state;
    }

    case RESET_PAGE_TO_VIEWED: {
      return {};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/addPageToViewed.js